import { BloodType } from "../types/personal_info.types";

export const BLOOD_TYPE_OPTIONS = [
  { key: BloodType.A_POSITIVE, value: "A+" },
  { key: BloodType.A_NEGATIVE, value: "A-" },
  { key: BloodType.B_POSITIVE, value: "B+" },
  { key: BloodType.B_NEGATIVE, value: "B-" },
  { key: BloodType.AB_POSITIVE, value: "AB+" },
  { key: BloodType.AB_NEGATIVE, value: "AB-" },
  { key: BloodType.O_POSITIVE, value: "O+" },
  { key: BloodType.O_NEGATIVE, value: "O-" },
];
